const preventPageUnload = (event: BeforeUnloadEvent) => {
  event.preventDefault();
};

let refCount = 0;

export const addUnloadListener = () => {
  refCount++;
  if (refCount === 1) {
    window.addEventListener('beforeunload', preventPageUnload);
  }
};

export const removeUnloadListener = () => {
  refCount = Math.max(0, refCount - 1);
  if (refCount === 0) {
    window.removeEventListener('beforeunload', preventPageUnload);
  }
};
